import { withStyles } from '@material-ui/core/styles';
import CommunitySearch from './CommunitySearch';
import styles from './styles';

export default withStyles(styles)(CommunitySearch);
